export default "__VITE_ASSET__DuksPcSW__"